import { SelectEffect, PutEffect, select, put } from 'redux-saga/effects';
import cloneDeep from 'lodash.clonedeep';

import { SetAudioClipTitleAction } from 'js/actionCreators/audioActions';
import { ExistingScribeModel } from 'js/types';
import { updateScribe } from 'js/actionCreators/scribeActions';

import { getProjectById } from '../selectors';

export function* updateAudioClipTitleSaga(
  action: SetAudioClipTitleAction
): Generator<SelectEffect | PutEffect, void, ExistingScribeModel | undefined> {
  const { projectId, clipId, title } = action;
  const project = yield select(getProjectById, projectId);

  if (!project) return;

  const newProject = cloneDeep(project);
  const audioClip = newProject.audioClips?.find(clip => clip.id === clipId);

  if (!audioClip) return;

  audioClip.filename = title;

  yield put(updateScribe(newProject));
}
